/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import $ from 'jquery'
import {ExcelExport, grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import {message} from 'antd'
import cookie from 'react-cookies'
import Select from 'react-select'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import SearchProduct from '../BaseComponent/SearchProduct'
import Loader from '../loaders/loader'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class SupplierOrder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      lengthbaskets: 0,
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      supplierOrder: [],
      providers: [],
      printInfo: [],
      selectedOption: [],
      excelData: [],
      fromDate: '',
      toDate: '',
      aggregation: {},
      buttonClicked: false,
      itemInfo: {},
      providerArr: [],
      multiProvider: [],
      arrayOfStocks: [],
      finalStocks: [],
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'productName_desc',
      sortData: [
        {
          name: 'تاریخ سفارش',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد در سفارش',
          value: 'supplyQuantity',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کدمحصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شماره فاکتور',
          value: 'invoiceNum',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد',
          value: 'alternativeQuantity',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'واحد شمارش',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'قیمت واحد',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'قیمت کل',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تخفیف سایت',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تخفیف تامین کننده',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'قابل پرداخت',
          value: 'alternativeUnitTitle',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      tablePageNumber: 1
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`report/supplier/item`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              supplierOrder: response.data.object.result,
              countAll: response.data.object.countAll,
              aggregation: response.data.object.aggregation,
              toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
              fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
              buttonClicked: true,
              itemInfo: response.data.object.aggregation.itemInfo,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              aggregation: response.data.object.aggregation,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let {providerId, finalStocks} = this.state
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value).trim()
    let totalAmountMin = this.convertDigit(document.getElementById('totalAmountMin').value.trim())
    let totalAmountMax = this.convertDigit(document.getElementById('totalAmountMax').value.trim())
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (providerId) {
      filter.providerIds = providerId
    }
    if (finalStocks.length !== 0) {
      filter.stockProductIds = finalStocks.join(',')
    }
    if (minDate !== '') {
      filter.supplyDateMin = minDate
    }
    if (maxDate !== '') {
      filter.supplyDateMax = maxDate
    }
    if (invoiceNum !== '') {
      filter.invoiceNum = invoiceNum.trim()
    }
    if (invoiceId !== '') {
      filter.invoiceId = invoiceId.trim()
    }
    if (totalAmountMin !== '') {
      filter.quantityMin = totalAmountMin.trim()
    }
    if (totalAmountMax !== '') {
      filter.quantityMax = totalAmountMax.trim()
    }
    return filter
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})

    console.log(`Option selected:`, selectedOption)
  }

  handleDateChangeFrom = (date) => {
    this.setState({selectedDateFrom: date, selectedDateTo: date})
    // this.toDateInput.focus();
  }

  handleDateChangeTo = (date) => {
    this.setState({selectedDateTo: date})
    // this.toDateInput.focus();
  }

  componentDidMount() {
    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error == null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] = result[i].providerId + " - " + result[i].title;
    //       }

    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     }
    //     // alert(JSON.stringify(response.data))
    //   })
    //   .catch((error) => {
    //     alert(JSON.stringify(error));
    //   });

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      supplierOrder: data
    })
  }

  changeDropDown(data) {
    this.setState({
      supplierOrder: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  changeSelect(value) {
    this.setState({
      providerId: value
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value

    this.setState({
      tasvie: value == '' ? '' : Number(value)
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState({
        pageNumber: 1
      })
      setTimeout(() => {
        this.getReport(false)
      }, 500)
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(`report/supplier/item?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['supplyDate'] = jMoment(excelReport[i]['supplyDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['supplyTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['supplyTimeTo'].substr(0, 5)
            excelReport[i]['invoiceId'] = excelReport[i]['invoice'].invoiceId
            excelReport[i]['invoiceNum'] = excelReport[i]['invoice'].invoiceNum
            excelReport[i]['websiteTakhfif'] =
              Number(excelReport[i]['websiteDiscountAmount']) + Number(excelReport[i]['websiteExtraDiscountAmount'])
            excelReport[i]['providerTakhfif'] =
              Number(excelReport[i]['providerDiscountAmount']) + Number(excelReport[i]['providerExtraDiscountAmount'])
          }
          this._export.save(this.state.excelReport)
        }
        // else {
        //     $('.showBaseTable,.print').fadeOut();
        //     // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        // }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'تاریخ سفارش',
      'تعداد در سفارش',
      'کد محصول',
      'نام محصول',
      'تامین کننده',
      'شماره فاکتور',
      'شناسه فاکتور',
      'تعداد',
      'واحد شمارش',
      'قیمت واحد',
      'کل',
      'تخفیف سایت',
      'تخفیف تامین کننده',
      'قابل پرداخت'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست گزارش سفارش تامین کنندگان"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={15}
              rightColSpan={6}
              centerColSpan={1}
              leftColSpan={8}
              centerSection={''}
              rightSection={'تاریخ ثبت از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((items, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {jMoment(items.supplyDate).format('jYYYY/jM/jD') +
                      ' , ' +
                      items.supplyTimeFrom.substr(0, 5) +
                      ' - ' +
                      items.supplyTimeTo.substr(0, 5)}
                  </td>
                  <td>{items.supplyQuantity}</td>
                  <td>{items.providerName}</td>
                  <td>{items.item.articleId}</td>
                  <td>{items.item.productName}</td>
                  <td>{items.invoice.invoiceId}</td>
                  <td>{items.invoice.invoiceNum}</td>
                  <td>{items.item.alternativeQuantity}</td>
                  <td>{items.item.alternativeUnitTitle}</td>
                  <td className="priceCell">{accounting.formatMoney(items.item.unitPrice, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.item.totalAmount, '', ',')}</td>
                  <td className="priceCell">
                    {accounting.formatMoney(Number(items.item.websiteDiscountAmount), '', ',')}
                  </td>
                  <td className="priceCell">
                    {accounting.formatMoney(Number(items.item.providerDiscountAmount), '', ',')}
                  </td>
                  <td className="priceCell">{accounting.formatMoney(items.item.payableAmount, '', ',')}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={2} />
                <td>{this.state.aggregation.supplyQuantity}</td>
                <td colSpan={5} />
                <td>{this.state.itemInfo.alternativeQuantity}</td>
                <td />
                <td className="priceCell">{accounting.formatMoney(this.state.itemInfo.unitPrice, '', ',')}</td>
                <td className="priceCell">{accounting.formatMoney(this.state.itemInfo.totalAmount, '', ',')}</td>
                <td className="priceCell">
                  {accounting.formatMoney(this.state.itemInfo.websiteDiscountAmount, '', ',')}
                </td>
                <td className="priceCell">
                  {accounting.formatMoney(this.state.itemInfo.providerDiscountAmount, '', ',')}
                </td>
                <td className="priceCell">{accounting.formatMoney(this.state.itemInfo.payableAmount, '', ',')}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش سفارش تامین کنندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'supplyDate'}
                field={'supplyDate'}
                title={'تاریخ سفارش'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'articleId'}
                field={'item.articleId'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productName'}
                field={'item.productName'}
                title={'نام محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'alternativeQuantity'}
                field={'item.alternativeQuantity'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'alternativeUnitTitle'}
                field={'item.alternativeUnitTitle'}
                title={'واحد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'unitPrice'}
                field={'item.unitPrice'}
                title={'قیمت واحد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalAmount'}
                field={'item.totalAmount'}
                title={'قیمت کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'websiteTakhfif'}
                field={'item.websiteDiscountAmount'}
                title={'تخفیف سایت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerTakhfif'}
                field={'item.providerDiscountAmount'}
                title={'تخفیف تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'item.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ سفارش از"
                  toLabel="تاریخ سفارش تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceId" name="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                                    <Select
                                        value={this.state.multiProvider}
                                        onChange={this.handleChangeProvider}
                                        options={this.state.providers}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder=''
                                    /> */}
                </div>

                <div className="formComponent">
                  <label>تعداد از :</label>
                  <input type="text" className="form-control" id="totalAmountMin" name="totalAmountMin" />
                </div>

                <div className="formComponent">
                  <label>تعداد تا :</label>
                  <input type="text" className="form-control" id="totalAmountMax" name="totalAmountMax" />
                </div>
              </div>
              <div>
                <SearchProduct getStocks={this.getStocks} finalStocks={this.finalStocks} />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable" ref={(node) => (this.printTable = node)}>
                <tbody>
                  <tr className="firstRow">
                    <td rowSpan={2}>ردیف</td>
                    <td colSpan={3}>سفارش</td>
                    <td colSpan={2}>محصول</td>
                    <td colSpan={2}>فاکتور</td>
                    <td colSpan={7}>ریز فاکتور</td>
                  </tr>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.supplierOrder.map((items, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>
                        {jMoment(items.supplyDate).format('jYYYY/jM/jD') +
                          ' , ' +
                          items.supplyTimeFrom.substr(0, 5) +
                          ' - ' +
                          items.supplyTimeTo.substr(0, 5)}
                      </td>
                      <td>{items.supplyQuantity}</td>
                      <td>{items.providerName}</td>
                      <td>{items.item.articleId}</td>
                      <td>
                        <a
                          target="_blank"
                          href={productShop({
                            articleId: items.item.articleId
                          })}
                        >
                          {items.item.productName}
                        </a>
                      </td>
                      <td>{items.invoice.invoiceId}</td>
                      <td>{items.invoice.invoiceNum}</td>
                      <td>{items.item.alternativeQuantity}</td>
                      <td>{items.item.alternativeUnitTitle}</td>
                      <td className="priceCell">{accounting.formatMoney(items.item.unitPrice, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(items.item.totalAmount, '', ',')}</td>
                      <td className="priceCell">
                        {accounting.formatMoney(Number(items.item.websiteDiscountAmount), '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(Number(items.item.providerDiscountAmount), '', ',')}
                      </td>
                      <td className="priceCell">{accounting.formatMoney(items.item.payableAmount, '', ',')}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={2} />
                    <td>{this.state.aggregation.supplyQuantity}</td>
                    <td colSpan={5} />
                    <td>{this.state.itemInfo.alternativeQuantity}</td>
                    <td />
                    <td className="priceCell">{accounting.formatMoney(this.state.itemInfo.unitPrice, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(this.state.itemInfo.totalAmount, '', ',')}</td>
                    <td className="priceCell">
                      {accounting.formatMoney(this.state.itemInfo.websiteDiscountAmount, '', ',')}
                    </td>
                    <td className="priceCell">
                      {accounting.formatMoney(this.state.itemInfo.providerDiscountAmount, '', ',')}
                    </td>
                    <td className="priceCell">{accounting.formatMoney(this.state.itemInfo.payableAmount, '', ',')}</td>
                  </tr>
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SupplierOrder
